import { useEffect, useState } from 'react';
import type { GameHost, SkinId } from '../../game/types.js';

/**
 * Car shell switcher, mirroring the scene switcher: the list comes from `host.skins`, which the
 * game publishes (via the pure `game/car-skins.ts` registry), so the UI never hardcodes ids.
 */
export function ShellSwitcher({ host, shell, skins }: { host: GameHost; shell: SkinId; skins: Array<{ id: SkinId; label: string }> }) {
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setBusy(false);
    }, [shell]);

    if (skins.length < 2) {
        return null;
    }

    return (
        <div className="shell-switcher" role="group" aria-label="车壳切换">
            {skins.map(candidate => (
                <button
                    key={candidate.id}
                    type="button"
                    className={candidate.id === shell ? 'shell-button active' : 'shell-button'}
                    disabled={busy}
                    onClick={() => {
                        if (candidate.id !== shell) {
                            setBusy(true);
                            host.setShell(candidate.id);
                        }
                    }}
                >
                    {candidate.label}
                </button>
            ))}
        </div>
    );
}
